import { refreshToken } from '../actions/signup-async';
import { REFRESH_KIOSK_TOKEN, REFRESH_TOKEN } from '../config/const';
import store from '../store';
import { invalidateUser, refreshTokenPending } from '../reducers/userReducer';
import { openModal } from '../reducers/modalReducer';

export async function getValidToken() {
  const tokens = store.getState().user.tokens;
  const refreshTokenValid = Date.now() < Date.parse(tokens.refreshTokenExpiredIn);
  const tokenValid = Date.now() < Date.parse(tokens.tokenExpiredIn);

  if (tokenValid) return Promise.resolve(tokens.token);

  if (!tokenValid && refreshTokenValid) {
    store.dispatch(refreshTokenPending(true));
    // check if refresh pending
    if (tokens.refreshTokenPending) {
      return new Promise((resolve, reject) => setTimeout(() => resolve(getValidToken()), 0));
    }
    // request new token
    return refreshToken(tokens.refreshToken).then(
      response => {
        store.dispatch({
          type: REFRESH_TOKEN,
          payload: response.data
        });
        store.dispatch(refreshTokenPending(false));
        return response.data.token;
      }
    ).catch(error => {
      store.dispatch(invalidateUser());
    });
  }

  return Promise.resolve(null);
}


export async function getValidTokenKiosk() {
  const kioskTokens = store.getState().kioskUser.tokens;
  const kioskRefreshTokenValid = Date.now() < Date.parse(kioskTokens.refreshTokenExpiredIn);
  const kioskTokenValid = Date.now() < Date.parse(kioskTokens.tokenExpiredIn);
  if (kioskTokenValid) {
    return Promise.resolve(kioskTokens.token);
  }

  if (!kioskTokenValid) {
    if (kioskRefreshTokenValid) {
      store.dispatch(refreshTokenPending(true));
      // check if refresh pending
      if (kioskTokens.refreshTokenPending) {
        return new Promise((resolve, reject) => setTimeout(() => resolve(getValidToken()), 0));
      }

      // request new token
      return refreshToken(kioskTokens.refreshToken).then(
        response => {
          store.dispatch({
            type: REFRESH_KIOSK_TOKEN,
            payload: response.data
          });
          store.dispatch(refreshTokenPending(false));
          return response.data.token;
        }
      ).catch(error => {
        store.dispatch(
          openModal({
            modalType: 'KIOSK_LOGIN_FORM',
            modalProps: {}
          })
        );
      });

    } else {
      // axios interceptor will fire event
    }
  }

  return Promise.resolve(null);
}

export function authFormDataHeader(token) {
  return {
    headers: {
      Authorization: `token ${token}`,
      'Content-Type': 'multipart/form-data'
    }
  };
}

export function authHeader(token) {
  return {
    headers: {
      Authorization: `token ${token}`
    }
  };
}



// WEBPACK FOOTER //
// ./src/services/getValidToken.js